import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";

@injectable()
export class GetCatalogByIdPlanExtensionUseCase {
    private _repository: PlanExtensionsCatalogRepository;

    constructor(@inject(PlanExtensionsCatalogRepository) repository: PlanExtensionsCatalogRepository) {
        this._repository = repository;
    }

    public call(id: string): Promise<PlanExtensionCatalogEntity> {
        return this._repository.getCatalogById(id);
    }
}
